<template>
  <div>
    <v-file-input 
    v-model="selectedFile" 
    label="Select File" 
    accept=".xls,.xlsx"
    @change="getJsonData()">
</v-file-input>
  </div>
</template>

<script>
export default {
    data: () => ({
        selectedFile:null
    }),
    methods: {
        getJsonData() {
            const XLSX = window.XLSX
            //XLSX.utils.json_to_sheet(data, 'out.xlsx');
            if (this.selectedFile) {
                const fileReader = new FileReader();
                fileReader.readAsBinaryString(this.selectedFile);
                fileReader.onload = (event) => {
                    const data = event.target.result;
                    const workbook = XLSX.read(data, { type: "binary" });
                    workbook.SheetNames.forEach(sheet => {
                        const rowObject = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheet]);
                        this.$emit('json-data',rowObject);
                        
                    });
                }
            }

        }
    }
}
</script>

<style>

</style>